export type UploadProvider = 'kvd' | 'kts' | 'hez' | 'hcs' | 'kvbo';
export type UploadField = 'hvd' | 'hts' | 'hez' | 'jks' | 'kvbo';
export type UploadStage = 'RECEIVING' | 'PARSING' | 'COMPLETED' | 'INCOMPLETE' | 'FAILED';
export type UploadFailureReason = 'CONNECTION_CLOSED' | 'UPLOAD_FAILED' | 'PARSING_ABORTED' | 'NO_FILE' | 'NO_OUTCOME';

export interface IUploadLogEntry {
	at: string;
	level: 'log' | 'warn' | 'error';
	message: string;
}

export interface IUploadStatus {
	uploadId: string;
	provider: UploadProvider;
	stage: UploadStage;
	failureReason?: UploadFailureReason;
	fileNames: string[];
	bytesReceived: number;
	bytesTotal: number;
	percent?: number;
	rowsSent: number;
	chunksSent: number;
	truncated: boolean;
	stalled: boolean;
	startedAt: string;
	bodyReceivedAt?: string;
	finishedAt?: string;
	elapsedMs: number;
	idleMs: number;
	log: IUploadLogEntry[];
}

export interface IUploadRequest {
	uploadId: string;
	provider: UploadProvider;
	fileName: string;
	startedAt: string;
	state: 'pending' | 'accepted' | 'error';
	previousUploadIds: string[];
}

export interface IProviderUpload {
	status?: IUploadStatus;
	request?: IUploadRequest;
}

export const UPLOAD_PROVIDERS: Record<UploadField, UploadProvider> = {
	hvd: 'kvd',
	hts: 'kts',
	hez: 'hez',
	jks: 'hcs',
	kvbo: 'kvbo',
};
